import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { autoEnablePushIfPossible } from '../../serviceWorkerRegistration';

// Тихая синхронизация push-подписки. Разрешение браузера здесь не запрашиваем:
// его спрашивает только кнопка «Включить» в профиле. Если человек уже разрешил
// уведомления раньше, сохраняем подписку на сервере, чтобы они начали приходить.
const PushNotificationSubscriber = () => {
  const userId = useSelector((s) => s.getMayInfoReducer?.myinfo?._id);

  useEffect(() => {
    if (!userId) return;
    if (typeof window === 'undefined' || !('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;

    autoEnablePushIfPossible().catch((error) => {
      console.warn('Не удалось синхронизировать push-подписку:', error?.message || error);
    });
  }, [userId]);

  return null;
};

export default React.memo(PushNotificationSubscriber);
